module.exports = __webpack_public_path__ + "img/people_zdb.5c602576.png";